import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class LocationFeed extends CRUDService {
  constructor() {
    super(APIPath.locationsFeeds);
  }

  generateUrl(feedType, params) {
    return BaseService.get(
      `${
        APIPath.locationsFeedsGenerateUrl
      }/${feedType}?${CommonUtility.objectToParams(params)}`,
    );
  }

  getFeedTemplate(feedType, params) {
    return BaseService.get(
      `${
        APIPath.locationsFeedsTemplate
      }/${feedType}/?${CommonUtility.objectToParams(params)}`,
    );
  }
}

const LocationFeedService = new LocationFeed();
Object.freeze(LocationFeedService);
export { LocationFeedService };
